/* eslint no-underscore-dangle: ["error", { "allow": ["_links", "_items"] }] */
import queryString from 'query-string';
import crud from './crud';
import settings from '../../config/settings';

export const retrieveChannels = function retrieveChannels(page) {
  return function retrieveChannelsFunction(dispatch, getState) {
    const { session: { affiliateId } } = getState();

    return dispatch(crud.apiRead({
      type: 'channels',
      urlParams: {
        affiliateId,
        page,
      },
    }))
    .then((results) => {
      if (results._links.next && results._links.next.href !== null && settings.enable_all_data_fetch === true) {
        const params = queryString.parse(results._links.next.href.split('?')[1]);
        return dispatch(retrieveChannels(params.page || null));
      }
      return Promise.resolve();
    });
  };
};

export const retrieveChannelSubscriptions = function retrieveChannelSubscriptions(page) {
  return function retrieveChannelSubscriptionsFunction(dispatch, getState) {
    const { session: { userId } } = getState();

    return dispatch(crud.apiRead({
      type: 'channelSubscriptions',
      urlParams: {
        userId,
        page,
      },
    }))
    .then((results) => {
      if (results._links.next && results._links.next.href !== null && settings.enable_all_data_fetch === true) {
        const params = queryString.parse(results._links.next.href.split('?')[1]);
        return dispatch(retrieveChannelSubscriptions(params.page || null));
      }
      return Promise.resolve();
    });
  };
};



// WEBPACK FOOTER //
// ./src/state/actions/channels.js